export const meta = {
  id: '37-esteem-and-construction',
  order: 37,
  titleFi: 'Arvostus ja rakentaminen',
  titleEn: 'Esteem and construction',
  duolingoUnit: ['duo-43-esteem', 'duo-44-construction'],
  // + Sanapaja's own words this lesson first needs (docs/COURSE.md "Own words in the lessons"; waves/wave-NN/lessons.json)
  lemmaIds: [
    'nykēla',
    'aōla',
    'zirȳla',
    'jāla',
    'īlōnda',
    'jemēla',
    'pōntāla',
    'nēdākogon',
    '-ākogon',
    'rytsa',
    'lykāpsa',
    'ruarilaksa',
    'ohīlvos',
    'zenturlion',
    'vumbiarzy',
    'bōjurlion',
    'galry',
    'qīzalbar',
    'bardulion',
    'botion',
    'iderennion',
    'lōrtetion',
    'nerny',
    'ōñurlion',
    'sombāzmion',
    'amanengy',
    'geltialbar',
    'iōrion',
    'lōrty',
    'obvos',
    'sētelion',
    'teglion',
    'tembyrlion',
    'toron',
    'lenagon',
    'ezīmy',
    'tistālior',
    'ours:mīsindigon',
    'ours:raqnenka',
    'ours:pirtiapenka',
    'ours:umbirion', 'ours:albūljagon', 'ours:dijemvos', 'ours:ȳghāves',
    'ours:rijāzma',
    'ours:lentalbar',
    'ours:qrīdrijagon',
    'ours:gūrotruragon',
    'ours:jēdrīha',
    'ours:ōñepvenkir',
    'ours:anevurlion',
    'ours:dijennon',
    'ours:mantys',
    'ours:gasi',
  ],
  exampleIds: [
    'got-s7e04-001',
    'got-s4e06-016',
    'got-s5e03-007',
    'got-s3e05-002',
    'got-s3e06-007',
    'ex-1767d1db9a5f',
    'hotd-s3e08-006',
    'ex-6768c822f817',
    'got-s6e01-005',
    'ex-872e22ae9c8c',
    'ex-cfaf14bb8930',
    'hotd-s1e04-009',
    'ex-f610f972aa00',
    'ex-7c6117183b97',
    'ex-f1413971403a',
    'ex-1ac7afd720d8',
    'ex-c8933dfdc449',
    'ex-5a53cfc71ac1',
    'ex-2de825d91902',
    'hotd-s1e02-009',
    'ex-c0cdfb2dc707',
    'ex-62682d309e9c',
    'ex-577976f30a57',
    'ex-3a93211b1df7',
    'ex-f8f6079cdc44',
    'ex-5bb4fbd3218e',
    'ex-2389c9b76918',
    'ex-d1ebcd2d75bc',
    'ex-fcca3b8b012b',
    'ex-d354211ebcc6',
  ],
  sources: [
    'https://wiki.languageinvention.com/index.php?title=Appendix:High_Valyrian_Duolingo_Tips_and_Notes',
    'https://wiki.languageinvention.com/index.php?title=High_Valyrian_Grammar',
    'https://wiki.languageinvention.com/index.php?title=Īlōnda',
    'https://wiki.languageinvention.com/index.php?title=Pōntāla',
    'https://wiki.languageinvention.com/index.php?title=-ākogon',
    'https://wiki.languageinvention.com/index.php?title=Nēdākogon',
    'https://wiki.languageinvention.com/index.php?title=Morghākogon',
    'https://wiki.languageinvention.com/index.php?title=Rytsa',
    'https://wiki.languageinvention.com/index.php?title=-lion',
    'https://wiki.languageinvention.com/index.php?title=-urlion',
    'https://wiki.languageinvention.com/index.php?title=-albar',
    'https://wiki.languageinvention.com/index.php?title=-āzma',
    'https://wiki.languageinvention.com/index.php?title=-vos',
    'https://wiki.languageinvention.com/index.php?title=Tembyrlion',
    'https://wiki.languageinvention.com/index.php?title=Zenturlion',
    'https://wiki.languageinvention.com/index.php?title=Qīzalbar',
    'https://wiki.languageinvention.com/index.php?title=Sombāzmion',
    'https://wiki.languageinvention.com/index.php?title=Ohīlvos',
    'https://archiveofourown.org/works/87170256/chapters/239856036',
  ],
  // the week (docs/COURSE.md "Lesson hub")
  grammarAlso: ['declensions', 'personal', 'word-building', 'paateopas'],
  showLines: ['got-s7e04-001', 'got-s4e06-016', 'got-s5e03-007', 'got-s3e05-002', 'got-s3e06-007', 'hotd-s3e08-006', 'got-s6e01-005', 'hotd-s1e04-009', 'hotd-s1e02-009'],
  pronunciation: { focus: 'gh', words: ['iqighagon', 'morghūljagon', 'Ghīs', 'qrīdrughagon', 'ōghar'], lines: ['got-s7e04-001', 'got-s4e06-016', 'got-s5e03-007'] },
  letter: {
    fi: 'Kehu kumppaniasi kolmella lauseella ja kuvaile talo, jossa haluaisitte asua.',
    en: 'Praise your partner in three sentences and describe a house you would like to live in.',
  },
  scene: 'got-s6e01-1',
}

# Arvostus ja rakentaminen

Duolingon kaksi viimeistä osiota: arvostus (refleksiivipronominit, korostus ja <Hv>-ākogon</Hv>-verbit) ja rakentaminen (rakennusten nimet ja niiden taivutus). Lopuksi katsotaan, mitä kaikkea osaatte nyt.

## Arvostus

Jotta voisit ajatella itsestäsi hyvää valyriaksi, tarvitset sanan *itse*. Tämä oppitunti käsittelee arvostusta, omaa ja toisten, ja sen tärkein työkalu on **refleksiivipronomini**. Samaa pronominia käytetään myös korostamiseen, ja siinä suomalaisella on etumatkaa. Lopuksi tulee kaksi pientä erikoisuutta: verbiluokka, jonka objekti on lokatiivissa, ja adjektiivit, joiden äänteet muuttuvat vesisuvussa.

## Refleksiivipronominit

Refleksiivipronomini viittaa takaisin lauseen subjektiin, kuten suomen *itse*: *näen itseni*, *rauhoita itsesi*. Valyriassa se on itsenäinen sana, joka taipuu sijamuodoissa kuin mikä tahansa substantiivi.

Toisin kuin valyrian muut persoonapronominit, refleksiivit ovat **säännöllisiä**. Kaikki päättyvät *-la*:han tai *-da*:han, ja kaikki taipuvat kuin a-loppuinen kuusukuinen substantiivi. Kun osaat yhden, osaat kaikki. Tässä <Hv glossed>nykēla</Hv> ’minä itse’:

<Paradigm lemma="nykēla" />

Koko joukko:

- <Hv glossed>nykēla</Hv> – minä itse (yksikön 1. persoona)
- <Hv glossed>aōla</Hv> – sinä itse (yksikön 2. persoona)
- <Hv glossed>zirȳla</Hv> – hän itse, se itse (yksikön 3. persoona, kuu- ja aurinkosuku)
- <Hv glossed>jāla</Hv> – hän itse, se itse (yksikön 3. persoona, maa- ja vesisuku)
- <Hv glossed>īlōnda</Hv> – me itse (monikon 1. persoona)
- <Hv glossed>jemēla</Hv> – te itse (monikon 2. persoona)
- <Hv glossed>pōntāla</Hv> – he itse (monikon 3. persoona)

<Pronounce word="nykēla" />
<Pronounce word="īlōnda" />
<Pronounce word="pōntāla" />

Kaksi asiaa poikkeaa suomesta. Ensinnäkin suomi ilmaisee persoonan *itse*-sanan omistusliitteellä (*itseni, itsesi, itsensä, itsemme*), valyria kokonaan omalla sanallaan. Ajatus on silti tuttu: jokaisella persoonalla on oma muotonsa. Toiseksi valyrian 3. persoona jakautuu suvun mukaan kahtia. Suomen *hän* ja *se* eivät tässä auta, vaan valinta tehdään sen mukaan, minkä sukuiseen sanaan pronomini viittaa.

Tips & Notes huomauttaa vielä, että näitä pronomineja taivutetaan aina vain yksikössä. Myös <Hv glossed>īlōnda</Hv> ’me itse’ taipuu yksikön päättein (<Hv l="īlōnda" fi="itsemme (akkusatiivi)">īlōnde</Hv>, <Hv l="īlōnda" fi="itsemme (genetiivi)">īlōndo</Hv> …), vaikka se viittaa useaan. Kaikkia sijoja et luultavasti tarvitse kovin usein.

### Refleksiivi objektina

Daenerys rauhoittaa lohikäärmettään. <Hv>Aōle</Hv> on refleksiivin akkusatiivi:

<Line id="got-s7e04-001" />

<Compare fi="itse|si" hv="aōl|e" label="rauhoita itsesi: omistusliite ~ refleksiivin akkusatiivi" />

Postpositio <Hv>syt</Hv> vaatii genetiivin myös refleksiivipronominilta. <Hv glossed>Zirȳlo syt</Hv> on ’itsensä puolesta’:

<Line id="got-s4e06-016" />

<Hv>Jāla</Hv> viittaa maa- tai vesisukuiseen sanaan. Punainen papitar puhuu kuolemasta (<Hv>morghon</Hv>, maasuku), joten muoto on <Hv>jāle</Hv> eikä <Hv>zirȳle</Hv>:

<Line id="got-s5e03-007" />

Kun subjekti on monikossa, valitaan <Hv>pōntāla</Hv>. <Hv glossed>Pōntālo syt</Hv> on ’itsensä puolesta, omasta puolestaan’:

<Line id="got-s3e05-002" />

Sanakirjan mukaan monikon refleksiiveillä on myös vastavuoroinen merkitys ’toinen toisiaan’. Melisandren lauseessa pakanat eivät teurasta itseään vaan toisiaan:

<Line id="got-s3e06-007" />

## Korostus: kolme tasoa

Kuten englannissa, myös valyriassa refleksiivipronominia käytetään korostamiseen. Silloin se voi olla jopa **subjektina**. Korostuksen tasoja on kolme. Wikin kielioppisivu esittää ne näin:

- <Hv glossed>Gevī ȳdrā.</Hv> – ’Puhut kauniisti.’
- <Hv glossed>Ao gevī ȳdrā.</Hv> – ’*Sinä* puhut kauniisti.’
- <Hv glossed>Aōla gevī ȳdrā.</Hv> – ’*Sinä itse* puhut kauniisti.’

Tässä suomi auttaa paljon, koska portaat ovat täsmälleen samat. Suomikin jättää subjektipronominin pois (*puhut*), lisää sen korostaakseen (*sinä puhut*) ja vahvistaa sitä vielä sanalla *itse* (*sinä itse puhut*). Ero on vain siinä, että valyriassa tavallinen pronomini *korvautuu* kolmannella tasolla refleksiivillä. Kirjaimellisesti se on kuin sanoisi ”itsesi puhut kauniisti”.

<Example id="ex-1767d1db9a5f" />

Kaksi sääntöä:

- **Yhdessä lauseessa voi olla vain yksi refleksiivipronomini.**
- **Verbi taipuu pronominin oman persoonan mukaan.** <Hv>Nykēla</Hv> saa verbin yksikön 1. persoonaan, <Hv>jemēla</Hv> monikon 2. persoonaan. Tips & Notes mainitsee, että kielen vanhemmissa vaiheissa subjektina ollut refleksiivi sai verbin yksikön 3. persoonaan, mutta nykyään noudatetaan pronominin omaa persoonaa.

Rhaenyra lupaa tappaa Aegonin omin käsin. <Hv>Nykēla</Hv> on subjekti, ja verbi <Hv>sēninna</Hv> on yksikön 1. persoonan futuuri:

<Line id="hotd-s3e08-006" />

<Note>
Repliikin *pirte prūmie* on Petersonin mukaan virhe: konsonantilla alkavan applikatiiviverbin <Hv>vykynagon</Hv> objekti on genetiivissä, joten oikein olisi <Hv fi="petollisen sydämen">pirto prūmio</Hv> (Petersonin Conlang Dialogue -selitykset, 2026; myös wikin alaviite).
</Note>

<Example id="ex-6768c822f817" />

<Interlinear hv="Ñuhor hāedri renīs se nykēla avy ossēn|inna!" gloss="minun-AQ.ACC sisar-ACC koskea-IMP.2SG ja minä.itse-NOM sinä-ACC tappaa-FUT.1SG" fi="Koske siskooni, niin tapan sinut itse!" />

Monikossa sama: Zanrushin kysymyksessä <Hv glossed>jemēla</Hv> ’te itse’ on subjektina, ja verbi <Hv>ondurilāt</Hv> on monikon 2. persoonan futuuri.

<Line id="got-s6e01-005" />

<Note>Tips & Notes havainnollistaa samoja portaita lauseilla <Hv fi="Olin puhumassa kuningattarelle.">Dārie ȳdrēlen</Hv>, <Hv fi="Minä olin puhumassa kuningattarelle.">Nyke dārie ȳdrēlen</Hv> ja <Hv fi="Minä itse olin puhumassa kuningattarelle.">Nykēla dārie ȳdrēlen</Hv>, ja niiden englanninkielinen käännös on *I will speak to the queen*. Muoto <Hv glossed>ȳdrēlen</Hv> on kuitenkin imperfekti (’olin puhumassa’), jonka opit <LessonLink n={34}>oppitunnilla 34</LessonLink>. Futuuri olisi <Hv>ȳdrēnna</Hv>. Korostuksen portaat pätevät joka tapauksessa; käännöksen virhe on Tips & Notesissa (wikin sanakirja, verbin <Hv>ȳdragon</Hv> taivutustaulukko).</Note>

## Ovela objekti: -ākogon-verbit

Verbi <Hv glossed>nēdākogon</Hv> ’rohkaista, kannustaa’ ja kaikki muut *-ākogon*-loppuiset verbit ottavat suoran objektinsa **lokatiivissa**, eivät akkusatiivissa. Tips & Notes tiivistää: pidä varasi!

Johdin *-ākogon* tekee substantiivista verbin, jonka merkitys on suunnilleen ’muuttua joksikin, tulla joksikin’, ja johdokset saavat usein idiomaattisen merkityksen. <Hv glossed>Nēdākogon</Hv> on johdettu sanasta <Hv glossed>nēdys</Hv> ’rohkea ihminen’.

<Example id="ex-872e22ae9c8c" />

<Interlinear hv="Kirine kepa zȳhā hunenkā tal|ā nēdākot|as." gloss="iloinen-LUN.NOM isä-NOM hänen-LUN.LOC energinen-LUN.LOC tytär-LOC rohkaista-PRF.3SG" fi="Iloinen isä rohkaisi energistä tytärtään." />

Objektin kaikki kolme sanaa ovat lokatiivissa: adjektiivit taipuvat tavalliseen tapaan siinä sijassa, jonka verbi valitsee.

<Compare fi="tytär|tä" hv="tal|ā" label="rohkaista jotakuta: partitiivi ~ lokatiivi" />

Suomi ei tässä auta, mutta lokatiiviobjekti on helppo muistaa, kun tietää säännön koskevan koko verbiluokkaa. Sama pätee verbiin <Hv glossed>morghākogon</Hv> ’tappaa’, joka on johdettu adjektiivista <Hv glossed>morghe</Hv> ’kuollut’. Rhaenyran lauseessa sen objekti on <Hv>zirȳ</Hv>, pronominin <Hv>ziry</Hv> lokatiivi:

<Line id="hotd-s1e04-009" />

Refleksiivi ja lokatiiviobjekti voivat esiintyä yhdessä. <Hv l="pōntāla" fi="itseään">Pōntālā</Hv> on refleksiivin lokatiivi:

<Example id="ex-cfaf14bb8930" />

<Pronounce word="nēdākogon" />

## Epäsäännöllinen vesisuku

Adjektiivilla <Hv glossed>rytsa</Hv> ’terve, voimissaan’ on vesisuvussa erikoinen taivutus. Samasta sanasta tulee myös tervehdys <Hv l="rytsas">rytsas</Hv>.

Tavallisen <Term id="adjektiiviluokka">I-luokan</Term> adjektiivin vesisukuisissa muodoissa on usein *r* heti juuren jälkeen: <Hv glossed>kasta</Hv> ’sininen, vihreä’ saa monikon nominatiivin <Hv l="kasta">kastra</Hv>. Säännön mukaan <Hv>rytsa</Hv> saisi siis muodon \*rytsra, mutta se on valyrialaiselle liian raskas ääntää. Sen sijaan *ts + r* muuttuu *dj*:ksi: <Hv>rydja</Hv>.

<Paradigm lemma="rytsa" cases="nom,acc,gen,dat" numbers="sg,pl" filter="positive.pre.aquatic" />

Muutos koskee vain niitä päätteitä, jotka alkavat *r*:llä. Yksikön nominatiivi <Hv>rytsor</Hv> ei muutu, koska sen pääte on *-or*.

Sama ilmiö koskee kahta muuta konsonanttiyhtymää:

- *ps + r* → *bj*: <Hv glossed>lykāpsa</Hv> ’laiska’ → <Hv>lykābja</Hv>
- *ks + r* → *gj*: <Hv glossed>ruarilaksa</Hv> (verbin <Hv glossed>ruaragon</Hv> ’piiloutua, piilottaa’ partisiippi) → <Hv l="ruarilaksa">ruarilagja</Hv>

Suomi ei tässä auta, joten opettele kolme paria ulkoa: **ts → dj, ps → bj, ks → gj**, aina kun perässä olisi *r*.

<Pronounce word="rydja" />

<Example id="ex-f610f972aa00" />

<Example id="ex-7c6117183b97" />

## Harjoituslauseita

<Practice hv="Nykēle urnen." fi="Näen itseni." />

<Practice hv="Aōla vāedā." fi="Sinä itse laulat." />

<Practice hv="Taobā nēdākotan." fi="Rohkaisin poikaa." />

<Practice hv="Hāedri rydja issi." fi="Sisaret ovat terveitä." />

Kolmannessa poika on lokatiivissa (<Hv>taobā</Hv>), koska verbi on *-ākogon*-verbi. Neljännessä <Hv glossed>hāedar</Hv> ’sisar’ on vesisukuinen, joten monikon adjektiivi on <Hv>rydja</Hv>.

## Rakentaminen

Duolingon viimeinen osio rakentaa Valyrian vapaavaltaa: tornit, koulut, pajat, majatalot ja kirjastot. Tips & Notes ei tuo tähän uutta kielioppia; se vain toteaa, että opit rakentamisen sanastoa ja vapaavallan tavallisten rakennusten nimiä. Siksi tämä oppitunti tekee kaksi asiaa. Ensin katsotaan, miten rakennusten nimet on koottu tutuista osista, sillä se keventää 25 uuden sanan opettelua huomattavasti. Sitten katsotaan taaksepäin: mitä kaikkea osaat nyt, 37 oppitunnin jälkeen.

## Rakentaa: lenagon

Verbi <Hv glossed>lenagon</Hv> ’rakentaa’ on konsonanttivartaloinen, ja sen perfektivartalo on <Hv>lent-</Hv>: <Hv glossed>lentan</Hv> ’rakensin’.

<Example id="ex-f1413971403a" />

Lauseessa on kolme vanhaa tuttua: infinitiivi modaaliverbin <Hv>kostagon</Hv> kanssa (<LessonLink n={27}>oppitunti 27</LessonLink>), postpositio <Hv glossed>syt</Hv> ’jonkun puolesta’ genetiivin kanssa ja puhuttelu <Hv fi="kuninkaani">dārys ñuhys</Hv>.

<Example id="ex-1ac7afd720d8" />

<Pronounce word="lenagon" />

## Rakennusten nimet koostuvat osista

Sanakirja kertoo, miten useimmat tämän oppitunnin sanat ovat syntyneet. Kun tunnet johtimet, sana avautuu itsestään.

### -lion ja -urlion: paikka

Johtimilla *-lion* ja *-urlion* muodostetaan paikkaa tarkoittavia sanoja: paikka, joka liittyy kantasanaan. Suomessa samaa työtä tekevät *-la/-lä* ja *-sto/-stö*: *kahvila, sairaala, kirjasto*.

<Compare fi="kirja|sto" hv="tembyr|lion" label="paikan johdin: -sto ~ -lion" />

- <Hv glossed>tembyrlion</Hv> ’kirjasto’ ← <Hv glossed>tembyr</Hv> ’kirja’
- <Hv glossed>bardulion</Hv> ’koulu’ ← <Hv glossed>bardugon</Hv> ’kirjoittaa’
- <Hv glossed>sētelion</Hv> ’paja, sepänpaja’ ← <Hv glossed>sētegon</Hv> ’tehdä, luoda, takoa’
- <Hv glossed>teglion</Hv> ’lattia’ ← <Hv glossed>tegon</Hv> ’maa, maaperä’
- <Hv glossed>zenturlion</Hv> ’majatalo, hotelli’ ← <Hv glossed>zentys</Hv> ’vieras’
- <Hv glossed>bōjurlion</Hv> ’areena’ ← <Hv glossed>bōsir</Hv> ’penkki’
- <Hv glossed>ōñurlion</Hv> ’majakka’ ← <Hv glossed>ōños</Hv> ’valo’

Koulu on siis ’kirjoittamisen paikka’, majatalo ’vieraiden paikka’ ja majakka ’valon paikka’.

<Example id="ex-c8933dfdc449" />

### -ion: yleisjohdin

Lyhyempi *-ion* on sanakirjan mukaan monikäyttöinen: sillä muodostetaan paikkaa tarkoittavia sanoja, verbeistä toiminnan tai tilan nimiä ja yleisemminkin substantiiveja monenlaisista kantasanoista:

- <Hv glossed>botion</Hv> ’toimisto, työpaikka’ ← <Hv glossed>botagon</Hv> ’tehdä työtä, raataa’
- <Hv glossed>iderennion</Hv> ’oikeustalo’ ← <Hv glossed>iderennes</Hv> ’oikeudenkäynti’
- <Hv glossed>iōrion</Hv> ’rakennus’ ← <Hv glossed>iōragon</Hv> ’seistä’
- <Hv glossed>lōrtetion</Hv> ’kellari’ ← verbin <Hv glossed>lōrtegon</Hv> ’kaivaa tunnelia’ partisiippi

Rakennus on siis ’se, mikä seisoo’. Lohikäärmeoppitunnilta tuttu <Hv glossed>dijemion</Hv> ’lämpökammio’ on muodostettu samalla tavalla.

<Example id="ex-5a53cfc71ac1" />

### -albar ja -āzma: iso

Johtimet *-albar* ja *-āzma* ovat suurentavia: ’iso, suuri’.

- <Hv glossed>qīzalbar</Hv> ’torni’ ← <Hv glossed>qīzy</Hv> ’pylväs’ (iso pylväs)
- <Hv glossed>geltialbar</Hv> ’kokoontumispaikka, halli, basilika’ ← <Hv glossed>geltigon</Hv> ’peittää, kattaa’ (iso katettu tila)
- <Hv glossed>sombāzmion</Hv> ’linna, linnoitus’ ← <Hv glossed>somby</Hv> ’kilpi’ + *-āzma* + *-ion* (iso kilpi)

Linna on suuri kilpi. Muistisääntö syntyy itsestään.

<Example id="ex-2de825d91902" />

<Line id="hotd-s1e02-009" />

<Pronounce word="sombāzmion" />
<Pronounce word="qīzalbar" />

### -vos ja -y: välineet

Johtimella *-vos* muodostetaan verbeistä välineiden nimiä:

- <Hv glossed>ohīlvos</Hv> ’tikari, veitsi’ ← <Hv glossed>ohīlagon</Hv> ’pistää, lävistää’
- <Hv glossed>obvos</Hv> ’kaari, holvikaari’ ← <Hv glossed>obagon</Hv> ’taivuttaa, kaartaa’

Myös *-y* voi muodostaa välineen nimen: <Hv glossed>amanengy</Hv> ’kauha, lapio’ tulee verbistä <Hv glossed>amanengagon</Hv> ’kauhoa’. <Hv glossed>Vumbiarzy</Hv> ’huone’ taas on muodostettu partisiipista <Hv glossed>vumbiarza</Hv> ’jossa oleskellaan’ (<Hv glossed>vumbagon</Hv> ’jäädä, oleskella’). Huone on ’paikka, jossa ollaan’.

<Example id="ex-c0cdfb2dc707" />

<Example id="ex-62682d309e9c" />

Joidenkin sanojen rakenne ei ole läpinäkyvä. <Hv glossed>Galry</Hv> ’vasara’, <Hv glossed>nerny</Hv> ’ovi’, <Hv glossed>toron</Hv> ’tiili’ ja <Hv glossed>ezīmy</Hv> ’ikkuna’ täytyy yksinkertaisesti opetella.

## Rakennukset taipuvat samalla tavalla

Tämän oppitunnin kaikki *-ion*- ja *-lion*-loppuiset sanat ovat maasukuisia ja taipuvat kolmannen <Term id="deklinaatio">taivutusluokan</Term> *-ion*-tyypin mukaan. Kun osaat yhden, osaat kaikki:

<Paradigm lemma="tembyrlion" numbers="sg,pl" />

Kaksi asiaa kannattaa huomata. Yksikössä nominatiivi ja akkusatiivi ovat samat (<Hv>tembyrlion</Hv>), samoin datiivi ja lokatiivi (<Hv>tembyrliot</Hv>). Jälkimmäinen on rakennuksista puhuttaessa tärkeä, koska samalla muodolla sekä mennään jonnekin että ollaan jossakin:

<Example id="ex-f8f6079cdc44" />

<Example id="ex-3a93211b1df7" />

<Interlinear hv="Ñuhon botion bardul|io lōrtet|iot il|za." gloss="minun-TERR.NOM toimisto-NOM koulu-GEN kellari-LOC sijaita-PRS.3SG" fi="Toimistoni on koulun kellarissa." />

Verbi on <Hv>ilagon</Hv>, ei <Hv>sagon</Hv>. <LessonLink n={19}>Oppitunnilla 19</LessonLink> opit, että kun olla-verbin täydennyksenä on lokatiivi, käytetään verbiä <Hv glossed>ilagon</Hv> ’maata, olla jossakin’. Sijaintia voi tarkentaa myös genetiivillä ja sanoilla <Hv glossed>paktot</Hv> ’oikealla’ ja <Hv glossed>geptot</Hv> ’vasemmalla’:

<Example id="ex-5bb4fbd3218e" />

<Example id="ex-2389c9b76918" />

<Hv glossed>Tistālior</Hv> ’pankki’ on poikkeus: se taipuu kollektiivin tapaan (*-or*), ja kollektiivi saa verbin yksikköön (oppitunnit <LessonLink n={28}>28</LessonLink> ja <LessonLink n={31}>31</LessonLink>): <Hv l="aemagon">aemas</Hv>.

<Example id="ex-d1ebcd2d75bc" />

<Example id="ex-fcca3b8b012b" />

<Pronounce word="tembyrlion" />
<Pronounce word="ōñurlion" />

Ja ovi, jonka jokainen sarjan katsoja tuntee:

<Example id="ex-d354211ebcc6" />

<Example id="ex-577976f30a57" />

## Harjoituslauseita

<Practice hv="Tembyrlion bardulio paktot ilza." fi="Kirjasto on koulun oikealla puolella." />

<Practice hv="Qīzalbri lentan." fi="Rakensin tornin." />

<Practice hv="Zān iōrion lenilin." fi="Olimme eilen rakentamassa rakennusta." />

Toisessa <Hv>qīzalbri</Hv> on vesisukuisen sanan <Hv>qīzalbar</Hv> akkusatiivi. Kolmannessa on <LessonLink n={34}>oppitunnin 34</LessonLink> imperfekti, ja monikon 1. persoonassa on taas *n*: <Hv>lenilin</Hv>.

## Mitä osaat nyt

Tämä on viimeinen Duolingon osioita seuraava oppitunti. Pysähdy hetkeksi katsomaan, mitä on rakennettu. Jos jokin alla olevista tuntuu hataralta, sen oppitunti on aina auki kertausta varten.

**Äänteet ja kirjoitus.** Pitkät vokaalit, *y* ja *ȳ* sekä paino, joka on suomalaisen suurin ansa (oppitunnit <LessonLink n={1}>1</LessonLink>–<LessonLink n={4}>4</LessonLink>).

**Substantiivit.** Neljä sukua: kuusuku, aurinkosuku, vesisuku ja maasuku (oppitunnit <LessonLink n={7}>7</LessonLink>–<LessonLink n={9}>9</LessonLink>). Kahdeksan sijaa: nominatiivi ja akkusatiivi (<LessonLink n={5}>5</LessonLink>), genetiivi (<LessonLink n={10}>10</LessonLink>), datiivi (<LessonLink n={16}>16</LessonLink>), lokatiivi (<LessonLink n={19}>19</LessonLink>), vokatiivi (<LessonLink n={21}>21</LessonLink>), instrumentaali ja komitatiivi (<LessonLink n={23}>23</LessonLink>). Neljä lukua: yksikkö ja monikko (<LessonLink n={2}>2</LessonLink>), muutama ja kollektiivi (<LessonLink n={28}>28</LessonLink>, <LessonLink n={31}>31</LessonLink>, <LessonLink n={35}>35</LessonLink>) sekä muutamasta johdetut sanat (<LessonLink n={35}>35</LessonLink>). Lainasanojen taivutus (<LessonLink n={29}>29</LessonLink>) ja lohikäärmeiden ks-nimet (<LessonLink n={36}>36</LessonLink>).

**Adjektiivit.** Etu- ja jälkiasema (<LessonLink n={2}>2</LessonLink>), <Term id="mukautuminen">mukautuminen</Term> suvussa ja luvussa (<LessonLink n={8}>8</LessonLink>, <LessonLink n={15}>15</LessonLink>) ja sijassa (<LessonLink n={10}>10</LessonLink>, <LessonLink n={16}>16</LessonLink>, <LessonLink n={19}>19</LessonLink>, <LessonLink n={23}>23</LessonLink>), omistusadjektiivit (<LessonLink n={11}>11</LessonLink>), värit (<LessonLink n={20}>20</LessonLink>), adverbit (<LessonLink n={24}>24</LessonLink>), adjektiiviset substantiivit (<LessonLink n={20}>20</LessonLink>) ja vesisuvun äännemuutokset *ts → dj, ps → bj, ks → gj* (tällä oppitunnilla).

**Pronominit.** Demonstratiivit (<LessonLink n={6}>6</LessonLink>, <LessonLink n={28}>28</LessonLink>), persoona- ja omistuspronominit (<LessonLink n={18}>18</LessonLink>), refleksiivit ja korostus (tällä oppitunnilla).

**Verbit.** Olla-verbi (<LessonLink n={3}>3</LessonLink>), preesens (<LessonLink n={14}>14</LessonLink>), subjunktiivi ja kielto <Hv>daor</Hv> (<LessonLink n={17}>17</LessonLink>), käskyt (<LessonLink n={21}>21</LessonLink>), perfekti (<LessonLink n={22}>22</LessonLink>), futuuri (<LessonLink n={26}>26</LessonLink>), infinitiivi (<LessonLink n={27}>27</LessonLink>), passiivi (<LessonLink n={30}>30</LessonLink>), persoonattomat verbit (<LessonLink n={31}>31</LessonLink>), applikatiivit (<LessonLink n={33}>33</LessonLink>) ja imperfekti (<LessonLink n={34}>34</LessonLink>). Lisäksi verbit, jotka valitsevat sijansa omalla tavallaan: <Hv>gīmīmagon</Hv> (<LessonLink n={34}>34</LessonLink>), <Hv>lēdegon</Hv> ja <Hv>dohaeragon</Hv> (<LessonLink n={35}>35</LessonLink>) sekä *-ākogon*-verbit (tällä oppitunnilla).

**Lukusanat.** Yhdestä tuhansiin (<LessonLink n={25}>25</LessonLink>).

Osaat siis jo sanoa, kuka teki mitä, kenelle, missä, millä ja kenen kanssa – nyt, ennen ja huomenna, myönteisesti ja kieltäen – ja kertoa, mitä olit tekemässä, kun sinua odotettiin muualla. Se riittää jo kirjeeseen. Seuraavilla oppitunneilla jatketaan kieliopilla, jota Duolingo ei käsittele.

## Sanat

<Vocab />

<Check />
